import $ from "jquery";
import {isMobile} from "Core/screenSizes";

export const changeBackgroundImage = () => {
    let data_image_attr_name = 'data-image-default';

    if (isMobile())
        data_image_attr_name = 'data-image-mobile';

    $('.plate').each(function () {
        if ($(this).attr('data-image-mobile') === undefined)
            return;

        if ($(this).attr('data-image-mobile').indexOf('no-plate-photo') !== -1)
            $(this).attr('data-image-mobile', $(this).attr('data-image-default'));

        let tagWithBackground = $(this).children('.plate__bg-overlay');

        if ($(this).find('.plate__circle-img-wrapper').length)
            tagWithBackground = $(this).find('.plate__circle-img-wrapper');

        if ($(this).find('.plate__square-img-wrapper').length)
            tagWithBackground = $(this).find('.plate__square-img-wrapper');

        tagWithBackground.css('background-image', `url( ${$(this).attr(data_image_attr_name)})`);
    });
};
